import { render, staticRenderFns } from "./subCategoryInformation.vue?vue&type=template&id=2729ca68&"
import script from "./subCategoryInformation.vue?vue&type=script&lang=js&"
export * from "./subCategoryInformation.vue?vue&type=script&lang=js&"
import style0 from "./subCategoryInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports